import {
  Card,
  Grid,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import themeDefault from "../../../theme/theme";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../component/common/Button";
import OutlinedTextField from "../../component/common/OutlinedTextField";
import Spinner from "../../component/common/Spinner";
import CustomizedSnackbars from "../../component/common/Snackbar";
import DatasetStyle from "../../../styles/Dataset";
import { useDispatch, useSelector } from "react-redux";
import APITransport from "../../../../redux/actions/apitransport/apitransport";
import CreateNewDatasetInstanceAPI from "../../../../redux/actions/api/Dataset/CreateNewDatasetInstance";
import GetDatasetTypeAPI from "../../../../redux/actions/api/Dataset/GetDatasetType";
import MenuItems from "../../component/common/MenuItems";

const CollectionProject = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = DatasetStyle();
  const dispatch = useDispatch();
  const [instance_Name, setInstance_Name] = useState("");
  const [instance_Description, setInstance_Description] = useState("");
  const [datasettype, setDatasettype] = useState("");
  const [type, setType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    variant: "",
  });
  const [errors, setErrors] = useState({});

  const loggedInUserData = useSelector(
    (state) => state.fetchLoggedInUserData.data
  );
  const handleCreate = () => {
    setLoading(true);
    setErrors({});
    const CreateDatasetInstance = {
      instance_name: instance_Name,
      parent_instance_id: null,
      instance_description: instance_Description,
      dataset_type: datasettype,
      organisation_id: loggedInUserData?.organization?.id || "",
      users: [loggedInUserData.id],
    };
    const apiObj = new CreateNewDatasetInstanceAPI(CreateDatasetInstance);
    fetch(apiObj.apiEndPoint(), {
      method: "POST",
      body: JSON.stringify(apiObj.getBody()),
      headers: apiObj.getHeaders().headers,
    })
      .then(async (res) => {
        if (!res.ok) throw await res.json();
        else return await res.json();
      })
      .then((res) => {
        setLoading(false);
        navigate(`/datasets/${res.instance_id}`);
      })
      .catch((err) => {
        setErrors(err);
        setSnackbarState({
          open: true,
          message: "Failed to create dataset instance",
          variant: "error",
        });
        setLoading(false);
      });
  };

  const datasetType = useSelector((state) => state.GetDatasetType.data);

  const getProjectDetails = () => {
    const projectObj = new GetDatasetTypeAPI(id);
    dispatch(APITransport(projectObj));
  };

  useEffect(() => {
    getProjectDetails();
  }, []);

  useEffect(() => {
    if (datasetType && datasetType.length > 0) {
      let temp = [];
      datasetType.forEach((element) => {
        temp.push({
          name: element,
          value: element,
        });
      });
      setType(temp);
    }
  }, [datasetType]);

  const renderSnackBar = () => {
    return (
      <CustomizedSnackbars
        open={snackbarState.open}
        handleClose={() =>
          setSnackbarState({ open: false, message: "", variant: "" })
        }
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        variant={snackbarState.variant}
        message={snackbarState.message}
      />
    );
  };
  return (
    <ThemeProvider theme={themeDefault}>
      <Grid container direction="row">
        {loading && <Spinner />}
        <Card className={classes.workspaceCard}>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}></Grid>
          <Grid item xs={8} sm={8} md={8} lg={8} xl={8} sx={{ pb: "6rem" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h2" gutterBottom component="div">
                Create New Dataset Instance
              </Typography>
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                Instance_Name *:
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <OutlinedTextField
                fullWidth
                value={instance_Name}
                onChange={(e) => setInstance_Name(e.target.value)}
                required
                helperText={errors.instance_name ? errors.instance_name : ""}
                error={errors.instance_name ? true : false}
              />
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                Instance_Description:
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <OutlinedTextField
                fullWidth
                value={instance_Description}
                onChange={(e) => setInstance_Description(e.target.value)}
                helperText={
                  errors.instance_description ? errors.instance_description : ""
                }
                error={errors.instance_description ? true : false}
              />
            </Grid>
            <Grid
              className={classes.projectsettingGrid}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Typography gutterBottom component="div">
                Dataset_Type *:
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12} sm={12}>
              <MenuItems
                menuOptions={type}
                handleChange={(value) => setDatasettype(value)}
                value={datasettype}
                helperText={errors.dataset_type ? errors.dataset_type : ""}
                error={errors.dataset_type ? true : false}
              />
            </Grid>

            <Grid
              className={classes.projectsettingGrid}
              style={{}}
              item
              xs={12}
              md={12}
              lg={12}
              xl={12}
              sm={12}
              sx={{ mt: 3 }}
            >
              <Button
                style={{ margin: "0px 20px 0px 0px" }}
                label={"Confirm"}
                onClick={handleCreate}
                disabled={
                  instance_Name &&
                  datasettype &&
                  loggedInUserData.organization.id
                    ? false
                    : true
                }
              />

              <Button label={"Cancel"} onClick={() => navigate(`/datasets/`)} />
            </Grid>
            {renderSnackBar()}
          </Grid>
        </Card>
      </Grid>
    </ThemeProvider>
  );
};

export default CollectionProject;
